'use client';

import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { useToast } from './hooks/use-toast';
import { toastProviderContentRecipe } from './styles/toast-provider-content.styles';
import type { ToastProviderContentPropsInterface } from './types/toast-provider-content.types';

/**
 * ToastProvider.Content creates a fixed container to house the Toast list
 */
export const ToastProviderContent = forwardRef<HTMLDivElement, ToastProviderContentPropsInterface>(
  (props: ToastProviderContentPropsInterface, forwardedRef) => {
    const { 'aria-live': ariaLive = 'polite', children, className, css: cssProp, ...rest } = props;

    const { placement } = useToast();

    const styles = css(toastProviderContentRecipe.raw({ placement }), cssProp);

    return (
      <div
        ref={forwardedRef}
        className={cx('c11n', 'c11n_toast-provider__content', styles, className)}
        aria-live={ariaLive}
        data-c11n-component="ToastProvider.Content"
        data-c11n-version={__C11N_VERSION__}
        {...rest}
      >
        {children}
      </div>
    );
  },
);

ToastProviderContent.displayName = 'ToastProvider.Content';
